export default function ({ glideBehaviour, carouselId, numberOfCases, startAt }) {
    // if the carousel is a child inside fx. ThemeSection it needs to change according to the parents width and not the viewport, so we need to:

    // 1. find the featuredGroups and select it
    const featuredGroups = document.querySelector(`#${carouselId}`)

    // 2. find the parent and select it
    const parent = featuredGroups.parentNode

    // 3. find parent's width (maybe with .offsetWidth)
    const parentWidth = parent.offsetWidth

    // 4. change slider configs for cards according to the width of the parent instead of viewport.

    let glideConfig = {
        type: glideBehaviour,
        startAt: startAt ?? 0,
        perView: 2.1,
        gap: 22,
        peek: {
            after: 275,
            before: 0
        }
    }

    if (glideBehaviour === 'slider') {
        glideConfig.rewind = false
        glideConfig.bound = true
    }

    if (parentWidth < 600) {
        return {
            ...glideConfig,
            perView: 1,
            gap: 20,
            peek: {
                after: 75,
                before: 0
            }
        }
    } else if (numberOfCases == 2) {
        // If we only have 2 cards, we fall back on this breakpoint
        return {
            ...glideConfig,
            perView: 2,
            gap: 20,
            peek: {
                after: 75,
                before: 0
            }
        }
    } else if (parentWidth < 800) {
        return {
            ...glideConfig,
            perView: 1.95,
            gap: 20,
            peek: {
                after: 75,
                before: 0
            }
        }
    } else if (parentWidth < 1000) {
        return {
            ...glideConfig,
            perView: 2.1,
            gap: 20,
            peek: {
                after: 150,
                before: 0
            }
        }
    
    } else if (parentWidth < 1200) {
        return {
            ...glideConfig,
            perView: 2.8,
            gap: 20,
            peek: {
                after: 150,
                before: 0
            }
        }
    
    } else {
        return glideConfig
    }
}
